export default {
  departments: [],
  persons: [],
  departmentPersonDictionary: null,
  search: {
    in_departmentIds: [],
    ge_enterTime: '',
    le_enterTime: ''
  },
  abstractAddCountByDepartment: [],
  abstractClickCountByDepartment: [],
  abstractHotByDepartment: [],
  abstractAddCountByUser: [],
  userClickCount: [],
  abstractHot: [],
  wordByQueryCount: [],
  keywordByQueryCount: [],
}